import { render, staticRenderFns } from "./Encounter_tpProtection.vue?vue&type=template&id=838b7a2a&scoped=true&lang=html"
import script from "./Encounter_tpProtection.vue?vue&type=script&lang=js"
export * from "./Encounter_tpProtection.vue?vue&type=script&lang=js"
import style0 from "./Encounter_tpProtection.vue?vue&type=style&index=0&id=838b7a2a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "838b7a2a",
  null
  
)

export default component.exports